<template>
  <div class="flex flex-col min-h-screen">
    <div>
      <NavMain @showRightNav="showRightNav" />
    </div>

    <div
      class="grid grid-cols-6 sm:grid-cols-6 md:grid-cols-6 lg:grid-cols-6 xl:grid-cols-6"
    >
      <div
        class="hidden sm:hidden md:hidden lg:grid xl:grid lg:col-span-1 xl:col-span-1"
      >
        <SearchPane />
      </div>
      <div
        class="col-span-6 lg:grid xl:grid lg:col-span-4 xl:col-span-4 mt-0 sm:mt-0 md:mt-0 lg:mt-4 xl:mt-4 mx-0 sm:mx-0 md:mx-0 lg:mx-2 xl:mx-2"
        :class="{ hidden: hideAccommComp }"
      >
        <router-view />
      </div>
      <div
        class="col-span-6 lg:grid xl:grid lg:col-span-1 xl:col-span-1"
        :class="{ hidden: hideRightNav }"
      >
        <RightNavPane @showAccommComp="showAccommComp" />
      </div>
    </div>

    <div class="flex flex-grow">
      <Footer />
    </div>
  </div>
</template>

<script>
import NavMain from "../components/NavMain";
import Footer from "../components/Footer";
import SearchPane from "../components/AccommodatieSearch/Pane.vue";
import RightNavPane from "../components/RightNavPane/RightNavPane";
export default {
  components: {
    NavMain,
    SearchPane,
    RightNavPane,
    Footer
  },
  created() {
    if (this.hasPermission("read other users"))
      this.$store.dispatch("loadUsers");
  },
  data() {
    return {
      hideAccommComp: false,
      hideRightNav: true
    };
  },
  methods: {
    showAccommComp() {
      this.hideAccommComp = false;
      this.hideRightNav = true;
    },
    showRightNav() {
      this.hideAccommComp = true;
      this.hideRightNav = false;
    }
  }
};
</script>
